import { ExamContentsData } from "../type/examType";

const sampleIntroduction1 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎001.png";
const sampleQ1 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎002.png";
const sampleA1 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎003.png";
const sampleQ2 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎004.png";
const sampleA2 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎005.png";
const sampleQ3 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎006.png";
const sampleQ3Hint1 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎007.png";
const sampleA3 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎008.png";
const sampleQ4 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎009.png";
const sampleQ4Hint1 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎010.png";
const sampleA4 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎011.png";
const sampleIntroduction2 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎012.png";
const sampleQ5 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎013.png";
const sampleQ5Hint1 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎014.png";
const sampleA5 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎015.png";
const sampleIntroduction3 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎016.png";
const sampleQ6 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎017.png";
const sampleA6 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎018.png";
const sampleQ7 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎019.png";
const sampleQ7Hint1 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎020.png";
const sampleA7 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎021.png";
const sampleQ8 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎022.png";
const sampleA8 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎023.png";
const sampleQ9 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎024.png";
const sampleA9 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎025.png";
const sampleA9_2 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎026.png";
const sampleQ10 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎027.png";
const sampleQ10Hint1 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎028.png";
const sampleA10 = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/‎sample2.‎029.png";
const moshidoba = "https://storage.googleapis.com/enigma-workstudio.appspot.com/RDPG8ePQpDAu58cS/moshidoba.png";

export const defaultContents: ExamContentsData = {
  problems: [
    {
      title: ["セット1", "導入"],
      thumbnail: sampleIntroduction1,
      tab: [
        {
          title: "導入",
          list: [
            {
              type: "text",
              message: "検定システム開発用のサンプル問題です",
            },
            {
              type: "image",
              image: sampleIntroduction1,
            },
          ],
        },
      ],
    },
    {
      title: ["もし", "ドバ"],
      thumbnail: moshidoba,
      tab: [
        {
          title: "ムービー埋め込みのテスト",
          list: [
            {
              type: "text",
              message: "動画上部テキスト",
            },
            {
              type: "movie",
              src: "https://www.youtube.com/embed/DPZZOjLYUCs",
            },
            {
              type: "text",
              message: "動画下部テキスト",
            },
          ],
        },
      ],
    },
    {
      title: ["第", "1", "問"],
      thumbnail: sampleQ1,
      tab: [
        {
          title: "問題",
          list: [
            {
              type: "text",
              message: "以下の画像が表す歯科は？",
            },
            {
              type: "image",
              image: sampleQ1,
            },
          ],
        },
        {
          title: "解説",
          explanation: true,
          list: [
            {
              type: "image",
              image: sampleA1,
            },
          ],
        },
      ],
      answer: [
        {
          words: ["きぬた歯科", "きぬたしか"],
        },
      ],
    },
    {
      title: ["第", "2", "問"],
      thumbnail: sampleQ2,
      tab: [
        {
          title: "問題",
          list: [
            {
              type: "image",
              image: sampleQ2,
            },
          ],
        },
        {
          title: "解説",
          explanation: true,
          list: [
            {
              type: "image",
              image: sampleA2,
            },
          ],
        },
      ],
      answer: [
        {
          words: ["かたぬき", "型抜き", "カタヌキ"],
        },
      ],
    },
    {
      title: ["第", "3", "問"],
      thumbnail: sampleQ3,
      tab: [
        {
          title: "問題",
          list: [
            {
              type: "text",
              message: "以下の画像が表す東京の区は？",
            },
            {
              type: "image",
              image: sampleQ3,
            },
          ],
        },
        {
          title: "ヒント",
          list: [
            {
              type: "hint",
              buttonMessage: "ヒントを開放",
              hintId: "sampleQ3Hint1",
              list: [
                {
                  type: "image",
                  image: sampleQ3Hint1,
                },
              ],
            },
          ],
        },
        {
          title: "解説",
          list: [
            {
              type: "image",
              image: sampleA3,
            },
          ],
        },
      ],
      answer: [
        {
          words: ["かつしか", "葛飾", "葛飾区", "かつしかく"],
        },
      ],
    },
    {
      title: ["第", "4", "問"],
      thumbnail: sampleQ4,
      tab: [
        {
          title: "問題",
          list: [
            {
              type: "text",
              message: "以下の画像が表すものを答えよ",
            },
            {
              type: "image",
              image: sampleQ4,
            },
          ],
        },
        {
          title: "ヒント",
          list: [
            {
              type: "hint",
              buttonMessage: "ヒントを開放",
              hintId: "sampleQ4Hint1",
              list: [
                {
                  type: "image",
                  image: sampleQ4Hint1,
                },
              ],
            },
          ],
        },
        {
          title: "解説",
          list: [
            {
              type: "image",
              image: sampleA4,
            },
          ],
        },
      ],
      answer: [
        {
          words: ["いわ", "岩", "イワ"],
        },
      ],
    },
    {
      title: ["セット2", "導入"],
      thumbnail: sampleIntroduction2,
      tab: [
        {
          title: "問題",
          list: [
            {
              type: "text",
              message: "知識が必要な問題が出題されます。",
            },
            {
              type: "image",
              image: sampleIntroduction2,
            },
          ],
        },
        {
          title: "マークダウンのテスト",
          list: [
            {
              type: "markdown",
              body: "# 見出し1\n\nこれは見出し1です。\n\n## 見出し2\n\nこれは見出し2です。\n\n### 見出し3\n\nこれは見出し3です。\n\n#### 見出し4\n\nこれは見出し4です。\n\n##### 見出し5\n\nこれは見出し5です。\n\n###### 見出し6\n\nこれは見出し6です。\n\n## 段落\n\nこれは1つ目の段落の1行目です。  \nこれは1つ目の段落の2行目です。\n\nこれは2つ目の段落の1行目です。  \nこれは2つ目の段落の2行目です。\n\n## 順序無しリスト\n\nこれは順序無しリストです。\n\n- 1\n- 2\n    - 2-1\n    - 2-2\n        - 2-2-1\n        - 2-2-2\n- 3\n\nこれは順序無しリストです。\n\n## 順序付きリスト\n\nこれは順序付きリストです。\n\n1. 1\n1. 2\n    1. 2-1\n    1. 2-2\n        1. 2-2-1\n        1. 2-2-2\n1. 3\n\nこれは順序付きリストです。\n\n## 引用\n\nこれは引用です。\n\n> 引用\n> 引用\n\nこれは引用です。\n\n## コードブロック\n\nこれはコードブロックです。\n\n```ruby\nputs 1 + 1\n```\n\nこれはコードブロックです。\n\n## テーブル\n\nこれはテーブルです。\n\n| Left align | Right align | Center align |\n|:-----------|------------:|:------------:|\n| This       |        This |     This     |\n| column     |      column |    column    |\n| will       |        will |     will     |\n| be         |          be |      be      |\n| left       |       right |    center    |\n| aligned    |     aligned |   aligned    |\n\nこれはテーブルです。\n\n## リンク\n\nこれは [リンク](http://example.com) です。\n\n## コード\n\nこれは `puts 1 + 1` コードです。\n\n## 強い強調\n\nこれは **強い強調** です。\n\n## 強調\n\nこれは *強調* です。\n\n## 削除済みテキスト\n\nこれは ~~削除済みテキスト~~ です。\n\n### 定義リスト\n\nこれは定義リストです。\n\n<dl>\n  <dt>リンゴ</dt>\n  <dd>赤いフルーツ</dd>\n  <dt>オレンジ</dt>\n  <dd>橙色のフルーツ</dd>\n</dl>\n\nこれは定義リストです。\n\n## 水平線\n\nこれは水平線です。\n\n---\n\nこれは水平線です。\n\n## 画像\n\nこれは ![バナナ](https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Bananavarieties.jpg/220px-Bananavarieties.jpg) 画像です。",
            },
          ],
        },
      ],
    },
    {
      title: ["第", "5", "問"],
      thumbnail: sampleQ5,
      tab: [
        {
          title: "問題",
          list: [
            {
              type: "image",
              image: sampleQ5,
            },
          ],
        },
        {
          title: "ヒント",
          list: [
            {
              type: "hint",
              buttonMessage: "ヒントを開放",
              hintId: "sampleQ5Hint1",
              list: [
                {
                  type: "image",
                  image: sampleQ5Hint1,
                },
              ],
            },
          ],
        },
        {
          title: "解説",
          list: [
            {
              type: "image",
              image: sampleA5,
            },
          ],
        },
      ],
      answer: [
        {
          words: ["もくしろく", "黙示録", "モクシロク"],
        },
      ],
    },
    {
      title: ["セット2", "導入改"],
      thumbnail: sampleIntroduction3,
      tab: [
        {
          title: "導入",
          list: [
            {
              type: "image",
              image: sampleIntroduction3,
            },
          ],
        },
        {
          title: "ツイート埋め込みのテスト",
          list: [
            {
              type: "tweet",
              tweetId: "1342781474710286338",
            },
            {
              type: "tweet",
              tweetId: "1379021634930024450",
            },
          ],
        },
      ],
    },
    {
      title: ["第", "6", "問"],
      thumbnail: sampleQ6,
      tab: [
        {
          title: "問題",
          list: [
            {
              type: "image",
              image: sampleQ6,
            },
          ],
        },
        {
          title: "解説",
          list: [
            {
              type: "image",
              image: sampleA6,
            },
          ],
        },
      ],
      answer: [
        {
          words: ["気後れ", "きおくれ", "キオクレ"],
        },
      ],
    },
    {
      title: ["第", "7", "問"],
      thumbnail: sampleQ7,
      tab: [
        {
          title: "問題",
          list: [
            {
              type: "image",
              image: sampleQ7,
            },
          ],
        },
        {
          title: "ヒント",
          list: [
            {
              type: "hint",
              buttonMessage: "ヒントを開放",
              hintId: "sampleQ7Hint1",
              list: [
                {
                  type: "image",
                  image: sampleQ7Hint1,
                },
              ],
            },
          ],
        },
        {
          title: "解説",
          list: [
            {
              type: "image",
              image: sampleA7,
            },
          ],
        },
      ],
      answer: [
        {
          words: ["ねっせん", "熱線", "ネッセン", "熱戦"],
        },
      ],
    },
    {
      title: ["第", "8", "問"],
      thumbnail: sampleQ8,
      tab: [
        {
          title: "問題",
          list: [
            {
              type: "image",
              image: sampleQ8,
            },
          ],
        },
        {
          title: "解説",
          list: [
            {
              type: "image",
              image: sampleA8,
            },
          ],
        },
      ],
      answer: [
        {
          words: ["あいどる", "アイドル"],
        },
      ],
    },
    {
      title: ["第", "9", "問"],
      thumbnail: sampleQ9,
      tab: [
        {
          title: "問題",
          list: [
            {
              type: "image",
              image: sampleQ9,
            },
          ],
        },
        {
          title: "解説1",
          list: [
            {
              type: "image",
              image: sampleA9,
            },
          ],
        },
        {
          title: "解説2",
          list: [
            {
              type: "image",
              image: sampleA9_2,
            },
          ],
        },
      ],
      answer: [
        {
          words: ["ふがいない", "不甲斐ない", "フガイナイ"],
        },
      ],
    },
    {
      title: ["第", "10", "問"],
      thumbnail: sampleQ10,
      tab: [
        {
          title: "問題",
          list: [
            {
              type: "image",
              image: sampleQ10,
            },
          ],
        },
        {
          title: "ヒント",
          list: [
            {
              type: "hint",
              buttonMessage: "ヒントを開放",
              hintId: "sampleQ10Hint1",
              list: [
                {
                  type: "image",
                  image: sampleQ10Hint1,
                },
              ],
            },
          ],
        },
        {
          title: "解説",
          list: [
            {
              type: "image",
              image: sampleA10,
            },
          ],
        },
      ],
      answer: [
        {
          words: ["一般職", "いっぱんしょく", "イッパンショク"],
        },
      ],
    },
  ],
};
